import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

async function allBaseInfos() {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/all`,
    method: 'GET'
  })
}

// 列表
async function list(query) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}`,
    method: 'GET',
    params: query
  })
}

async function getById(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${id}`,
    method: 'GET'
  })
}

// 插入
async function insert(data) {
  return request({
    url: SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL,
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 更新
async function update(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.id}`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

// 删除
async function remove(id) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${id}`,
    method: 'DELETE'
  })
}

// 变更发布状态
async function changePublishStatus(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.id}/changePublishStatus`,
    method: 'PUT',
    data: qs.stringify({
      status: data.status
    })
  })
}

// 变更平台显示状态
async function changePlatformShowStatus(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.id}/changePlatformShowStatus`,
    method: 'PUT',
    data: qs.stringify({
      status: data.status
    })
  })
}

// 变更作品显示状态
async function changeContentShowStatus(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.id}/changeContentShowStatus`,
    method: 'PUT',
    data: qs.stringify({
      status: data.status
    })
  })
}

// 变更赛事状态
async function changeStatus(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.id}/changeStatus`,
    method: 'PUT',
    data: qs.stringify({
      status: data.status
    })
  })
}

// 快速创建活动
async function quickCreate(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/quickCreateCompetition`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取分享链接
async function getCompetitionShareUrl(data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.id}/getCompetitionShareUrl`,
    method: 'GET'
  })
}

// 获取活动下的所有比赛
async function allMatches(params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.id}/matches`,
    method: 'GET',
    params
  })
}

/** 活动管理 - 获取活动报名收入 */
async function getTotalCost(params) {
  // beginTime 和 endTime 作为路径参数，需要从 params 中提取
  const { id, beginTime, endTime, ...queryParams } = params
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${id}/totalcost/${beginTime}${endTime ? `/${endTime}` : ''}`,
    method: 'GET',
    params: queryParams
  })
}

/**
 * 查询当前分赛的报名表单配置信息
 * GET /merchant/simbart/competition/{id}/getEntryFormConfig
 * @param {Object} params
 * @param {Number|String} params.id - 赛事活动ID（路径参数）
 * @param {String} params.merchantId - 商户ID（查询参数）
 * @param {Number|String} params.stageId - 赛程ID（查询参数）
 * @param {Number|String} params.matchId - 分赛ID（查询参数）
 */
async function getEntryFormConfig(params) {
  const { id, merchantId, stageId, matchId } = params

  if (!id || !merchantId || !stageId || !matchId) {
    const missingParams = []
    if (!id) missingParams.push('id')
    if (!merchantId) missingParams.push('merchantId')
    if (!stageId) missingParams.push('stageId')
    if (!matchId) missingParams.push('matchId')
    throw new Error(`缺少必传参数：${missingParams.join('、')}`)
  }

  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${id}/getEntryFormConfig`,
    method: 'GET',
    params: {
      merchantId,
      stageId,
      matchId
    }
  })
}

/**
 * 更新报名记录（支持部分更新）
 * PATCH /merchant/simbart/competition/{id}/entry/{entryId}
 * @param {Object} params
 * @param {Number|String} params.id - 赛事活动ID（路径参数）
 * @param {Number|String} params.entryId - 报名记录ID（路径参数）
 * @param {String} params.merchantId - 商户ID（查询参数）
 * @param {Object} params.request - UpdateEntryRequest 请求体（支持部分字段更新）
 * @param {String} [params.request.content] - 报名详情 JSON 字符串
 * @param {String} [params.request.privateContent] - 私密详情 JSON 字符串
 * @param {String} [params.request.images] - 图片列表（逗号分隔）
 * @param {String} [params.request.videos] - 视频列表（逗号分隔）
 * @param {Number|String} [params.request.sessionId] - 场次ID
 * @param {String} [params.request.title] - 作品标题
 * @param {String} [params.request.intro] - 作品简介
 * @param {String} [params.request.cover] - 封面
 */
async function updateEntry(params) {
  const { id, entryId, merchantId, request: updateRequest } = params

  if (!id || entryId === null || entryId === undefined || !merchantId || !updateRequest) {
    const missingParams = []
    if (!id) missingParams.push('id')
    if (entryId === null || entryId === undefined) missingParams.push('entryId')
    if (!merchantId) missingParams.push('merchantId')
    if (!updateRequest) missingParams.push('request')
    throw new Error(`缺少必传参数：${missingParams.join('、')}`)
  }

  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${id}/entry/${entryId}`,
    method: 'PATCH',
    params: { merchantId },
    data: updateRequest
  })
}

export { getEntryFormConfig, updateEntry }

export default {
  allBaseInfos,
  list,
  getById,
  insert,
  update,
  remove,
  changePublishStatus,
  changePlatformShowStatus,
  changeContentShowStatus,
  changeStatus,
  quickCreate,
  getCompetitionShareUrl,
  allMatches,
  getTotalCost,
  getEntryFormConfig,
  updateEntry
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition.js